class BundleStep extends HTMLElement {
	constructor() {
		super();
	}  
	
	connectedCallback() {
      var _this;
      this.root = this;
      this.mobileWidth = 767;
      this.load = this.load.bind(this);      
      _this = this;
      _this.current_width = window.innerWidth;
      _this.display_type = _this.root.dataset.displayType;
      _this.section_id = _this.root.dataset.sectionId;
      _this.items = _this.root.querySelectorAll('.product--root');
      _this.load();
      
      // Firelight
      if ( typeof( window.evolvhBundleProducts ) == 'undefined' ) {
        window.evolvhBundleProducts = [];
        this.bundleProducts = window.evolvhBundleProducts;
        _this.initBundle();
      }
      else {
        this.bundleProducts = window.evolvhBundleProducts;
      }
    }
    
    initBundle() {
      var _this;
      _this = this;
      _this.initFloater();
      _this.bundleListeners();
    }
    
    bundleListeners() {
      var _this;
      _this = this;
      
      // ensure these only load once
      if ( typeof( window.bundleListenersLoaded ) === 'undefined' ) {
        document.addEventListener( 'header-stick', function(e) {
           floaterSize(); 
        });
          
        document.addEventListener( 'click', function(e) {
          const target = e.target.closest( 'product-quick-add[data-bundle-step="true"]:not(.has-options)' );
          
          if ( target !== null ) {
            e.preventDefault();
            const productRoot = target.closest( '.product--root' );
            const variantID = target.dataset.variantId;
            const image = productRoot.querySelector( '.product--image img' ).currentSrc;
            
            // add button will not appear if out of stock so no check is needed
            _this.addToBundle( variantID, image, 'grid' );
          }
        });

        document.addEventListener( 'click', function(e) {
            const target = e.target.closest( '.product-buy-buttons--primary:not([disabled="true"]) .product-buy-buttons--cta-bundle' );
            
            if ( target != null ) {
                e.preventDefault();
                const selectEl = target.closest( '.shopify-product-form' ).querySelector( '[name="id"]' );
                let available = selectEl.dataset.available;
                
                if ( available == 'false' ) {
                    available = false;
                }
                else {
                    available = true;
                }
                
                const variantID = parseInt( selectEl.value );
                
                if ( available ) {
                    const image = target.closest( '.product--quick-add--form').querySelector( 'product-media-variants .product-media--root[data-active="true"] img' ).src;
                    _this.addToBundle( variantID, image, 'sidebar' );
                }
            }
        });
          
        const floaterSize = (event) => {
          const floater = document.querySelector( '.bundle-floater' );
          let floaterClass = 'desktop';
          let removeClass = 'mobile';
          
          if ( window.innerWidth <= _this.mobileWidth ) {
            if ( event.type != 'scroll' ) {
              floaterClass = 'mobile';
              removeClass = 'desktop';
            }
            
            const header = document.querySelector( '.header--root' );
            const floaterTop = header.offsetTop + header.offsetHeight;
            //const announcements = document.querySelector( '.layout--header-group .announcement--root' );
            
            let adjustment = 0;
            
            if ( header.offsetTop > 0 ) {
                adjustment = window.scrollY;
            }
            
            floater.style.top = ( floaterTop - adjustment ) + 'px';
            document.querySelector( '.layout--main-content #main-content' ).style.paddingTop = ( floater.clientHeight - adjustment ) + 'px';
          }
          else {
            //document.querySelector( '.layout--main-content #main-content' ).style.paddingTop = 0;
          }
          if ( event.type != 'scroll' ) {
            floater.classList.remove( removeClass );
            floater.classList.add( floaterClass );
          }
        };
          
        const windowEvents = [ 'load', 'resize', 'orientationchange', 'scroll' ];
        
        windowEvents.forEach( (listener) => {
          window.addEventListener( listener, floaterSize );
        });
        
        const removeButtons = document.querySelectorAll( '.bundle-floater--remove-button' );
        removeButtons.forEach( (rb) => {
            rb.addEventListener( 'click', function(e) {
              const parent = this.closest( '.bundle-floater--product-item' );
              const index = parseInt( parent.dataset.index );

              gtag( 'event', 'Bundle - Remove Item', { 
                'variant_id': parent.dataset.variantId,
                'event_category': 'Bundle',
                'event_label': 'Remove Item'
              } );

              _this.bundleProducts.splice( index, 1 );
              _this.refreshFloater();
            });
        });
        
        const bundleATC = document.querySelector( '.bundle-floater--atc' );
        bundleATC.addEventListener( 'click', function(e) {
          e.preventDefault();
          _this.addBundleToCart();
        });
        
        const noticeClose = document.querySelector( '.bundle-floater--notice-container-close' );
        noticeClose.addEventListener( 'click', function(e) {
          const parent = this.closest( '.bundle-floater--notice-container' );
          parent.classList.remove( 'open' );
          parent.classList.add( 'closed' );
        });
      }
      
      window.bundleListenersLoaded = true;
    }
    
    addBundleToCart() {
      var _this;
      _this = this;
      
      if ( this.bundleProducts.length > 0 ) {
        gtag( 'event', 'Bundle - Add to Cart', { 
          'item_count': this.bundleProducts.length,
          'event_category': 'Bundle',
          'event_label': 'Add to Cart'
        } );
        
        let productData = [];
        
        this.bundleProducts.forEach( (bp) => {
          productData.push({
            quantity: 1,
            id: bp.variantID,
            properties: {
              _evolvh_bundle: true,
              _evolvh_website: true
            }  
          });
        });        
        
        const atcData = {
          items: productData
        }
        
        // post to cart endpoint
        fetch( '/cart/add.js', {
          method: 'POST',
          body: JSON.stringify( atcData ),
          credentials: 'same-origin',
          headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          },
        })
        .then( (response) => response.json().then(data => ({status: response.status, body: data})) )
        .then( function(data) {
          if ( String(data.status).indexOf(2) !== 0 ) {
            throw new Error( 'response status code returned was ' + data.status );
          }

          _this.clearBundle();
        })
        .catch( function (error) {
          console.warn( error );
        })
        .finally(function () {
          console.log( 'done processing ATC' );
        });
      }
    }
    
    clearBundle() {
      var _this;
      _this = this;

      this.bundleProducts = [];
      _this.refreshFloater();
    }
    
    addToBundle( variantID, image, context ) {
      var _this;
      _this = this;

      this.bundleProducts.push( {
        variantID: variantID,
        image: image
      });
      
      if ( context == 'sidebar' ) {
        document.querySelector( '.layout--viewport .layout--close' ).dispatchEvent( new Event( 'click' ) );
      }
      
      gtag( 'event', 'Bundle - Add Product', { 
        'variant_id': variantID,
        'event_category': 'Bundle',
        'event_label': 'Add Product'
      } );

      _this.checkForTrio();
      _this.refreshFloater();
      
      if ( context == 'trio-upgrade' ) {
        _this.showUpgrade();
      }
    }
    
    showUpgrade() {
      const notice = `Congrats, you unlocked a Healthy Hair Trio discount!`;
      const noticeHolder = document.querySelector( '.bundle-floater--notice-container' );
      const noticeText = document.querySelector( '.bundle-floater--notice-text' );
      noticeText.innerText( notice );
      noticeHolder.classList.remove( 'closed' );
      noticeHolder.classList.add( 'open' );
    }
    
    productIsAdded( variantID ) {
      for ( const[index, product] of this.bundleProducts.entries() ) {
        if ( variantID == product.variantID ) {
          return true;
        }
      }
      
      return false;
    }
    
    checkForTrio() {
      var _this;
      _this = this;
      
      if ( typeof( window.trioData ) !== 'undefined' ) {
        if ( window.trioData.length > 0 ) {
          for ( const[trioIndex, trioProduct] of window.trioData.entries() ) {
            if ( trioProduct.products.length > 0 ) {
              let bundleVariantsToRemove = [];
              
              for ( const[subIndex, subProduct] of trioProduct.products.entries() ) {
                if ( true === _this.productIsAdded( subProduct.variantID ) ) {
                  bundleVariantsToRemove.push( subProduct.variantID )
                }
                else {
                  bundleVariantsToRemove = [];
                  break
                }
              }
              
              // if we have variants remaining then they need to be removed and the trio added instead
              if ( bundleVariantsToRemove.length > 0 ) {
                bundleVariantsToRemove.forEach( (variantID) => {
                  for ( const [bpIndex, bpProduct] of _this.bundleProducts.entries() ) {
                    if ( parseInt( bpProduct.variantID ) == parseInt( variantID ) ) {
                      _this.bundleProducts.splice( bpIndex, 1 );
                      break;
                    }
                  }
                });
                
                // add the trio
                _this.addToBundle( trioProduct.variantID, trioProduct.image, 'trio-upgrade' )
              }
            }
          }
        }
      }
    }
    
    refreshFloater() {
      var _this;
      _this = this;
      
      const floater = document.querySelector( '.bundle-floater' );
      const floaterProducts = floater.querySelectorAll( '.bundle-floater--product-item' );
      floaterProducts.forEach( (fp, index) => {
        if ( index < this.bundleProducts.length ) {
          const product = this.bundleProducts[index];
          fp.dataset.variantId = product.variantID;
          fp.classList.add( 'active' );
          fp.style = 'background-image: url("' + product.image + '");'
        }
        else {
          delete fp.dataset.variantId;
          fp.classList.remove( 'active' );
          fp.style = '';
        }
      });
    }
    
    initFloater() {
      const floaterMarkup = `<aside class="bundle-floater">
        <div class="bundle-floater--notice-container closed">
          <div class="bundle-floater--notice-inner">
            <div class="bundle-floater--notice-container-close">x</div>
            <div class="bundle-floater--notice-text"></div>
          </div>
        </div>
        <ol class="bundle-floater--product-list">
          <li class="bundle-floater--product-item" data-discount="0" data-index="0">
            <span class="bundle-floater--remove-button">X</span>
          </li>
          <li class="bundle-floater--product-item" data-discount="0" data-index="1">
            <span class="bundle-floater--remove-button">X</span>
          </li>
          <li class="bundle-floater--product-item" data-discount="15" data-index="2">
            <span class="bundle-floater--remove-button">X</span>
            <div class="bundle-floater--discount-text">
              <svg viewBox="0 0 500 500">
                <path id="curve" d="M73.2,148.6c4-6.1,65.5-96.8,178.6-95.6c111.3,1.2,170.8,90.3,175.1,97" />
                <text width="500">
                  <textPath xlink:href="#curve">
                    15% Off
                  </textPath>
                </text>
              </svg>
            </div>
          </li>
          <li class="bundle-floater--product-item" data-discount="20" data-index="3">
            <span class="bundle-floater--remove-button">X</span>
            <div class="bundle-floater--discount-text">
              <svg viewBox="0 0 500 500">
                <path id="curve" d="M73.2,148.6c4-6.1,65.5-96.8,178.6-95.6c111.3,1.2,170.8,90.3,175.1,97" />
                <text width="500">
                  <textPath xlink:href="#curve">
                    20% Off
                  </textPath>
                </text>
              </svg>
            </div>
          </li>
          <li class="bundle-floater--product-item bundle-floater--plus" data-discount="25" data-index="4">
            <span class="bundle-floater--remove-button">X</span>
            <div class="bundle-floater--discount-text">
              <svg viewBox="0 0 500 500">
                <path id="curve" d="M73.2,148.6c4-6.1,65.5-96.8,178.6-95.6c111.3,1.2,170.8,90.3,175.1,97" />
                <text width="500">
                  <textPath xlink:href="#curve">
                    25% Off
                  </textPath>
                </text>
              </svg>
            </div>
          </li>
        </ol>
        <button class="btn bundle-floater--atc">Add<span class="hide-mobile"> to Bag</span></button>
      </aside>`;
      
      document.querySelector( '.layout--header-group' ).insertAdjacentHTML( 'beforeend', floaterMarkup );
    }

    load() {
      var _this;
      _this = this;
    }
}
const bundleStepEl = customElements.get("bundle-step");
bundleStepEl || customElements.define("bundle-step", BundleStep);